import { useState, useEffect } from "react";
import { makeApiCall } from "@lib/api/helpers";
import { getPromoNotificationsApi } from "@lib/api";
import { localClientStore } from "@lib/clientStore";

const LOCAL_EXPIRATION_DURATION = 86400000;

// generate localstorage key
const getLocalStoreKey = (toastId) => `promo-toast-${toastId}`;

const useToasts = ({ type, params, userInitial, setPromoToastVisible }) => {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const initialize = async () => {
      const res = await makeApiCall({
        apiArgs: [{ ...params, type }],
        apiCall: getPromoNotificationsApi,
        returnResponse: true,
      });

      if (res?.ok && res?.data?.[0]) {
        const serverToast = res.data[0];

        // we get dismissed toast data from localstorage
        const localStoreKey = getLocalStoreKey(serverToast.id);
        const isLocalDismissed = localClientStore.get(localStoreKey);

        if (!isLocalDismissed) {
          setToast(serverToast);
        }
      }
    };

    if (
      !userInitial &&
      (type === "homepage" ||
        (type === "category" && params?.categoryId) ||
        (type === "product" && params?.sku))
    ) {
      initialize();
    }
  }, [type, params, userInitial]);

  useEffect(() => {
    if (toast) {
      setPromoToastVisible(true);
    } else {
      setPromoToastVisible(false);
    }

    return () => setPromoToastVisible(false);
  }, [toast, setPromoToastVisible]);

  const setToastRead = (id) => {
    // localstorage key for current toast
    const localStoreKey = getLocalStoreKey(id);

    const expiration = new Date().getTime() + LOCAL_EXPIRATION_DURATION;
    // set the new dismissed toast in localstorage
    localClientStore.set(localStoreKey, "dismissed", expiration);

    setToast(null);
  };

  return {
    toast,
    setToastRead,
  };
};

export default useToasts;
